$(document).ready(function() {
  const $table = $('#settings-table');

  $table.DataTable({
    columnDefs: [{ orderable: false, targets: [1, 2, 3] }]
  });

  // Scroll to top on pager clicks
  $table.on('page.dt', function() {
    $('html, body').animate({
      scrollTop: $('body').offset().top
    }, 'fast');
  });
});
